import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  inject,
  signal
} from '@angular/core';
import { ComponentSizes, PcButtonIcon, GLOBAL_BREAKPOINTS, BusinessUnit } from '@pc/common';
import { ButtonDateType, DepartureReturnButtonState } from '../button-state.enum';
import { DatesButtonDisplayType, DepartureReturnDetailType } from '../departure-return-detail-type';
import { DepartureReturnDetailComponent } from '../departure-return-detail/departure-return-detail.component';

@Component({
  selector: 'pc-departure-return-btn-card',
  standalone: true,
  imports: [CommonModule, DepartureReturnDetailComponent],
  templateUrl: './departure-return-btn-card.component.html',
  styleUrl: './departure-return-btn-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartureReturnBtnCardComponent implements OnInit {
  @Input({ required: true }) public buttonDisplayType!: DatesButtonDisplayType;
  @Input({ required: true }) public dateEditText!: string;
  @Input({ required: true }) public dateEditDescription!: string;
  @Input({ required: true }) public departureAltText!: string;
  @Input({ required: true }) public returnAltText!: string;
  @Input() public dateDetail: DepartureReturnDetailType | undefined = undefined;
  @Input() public buttonActiveState: DepartureReturnButtonState = DepartureReturnButtonState.Departure;
  @Input() public buttonState: DepartureReturnButtonState = DepartureReturnButtonState.Departure;
  @Input() public dateType: ButtonDateType = ButtonDateType.Departure;
  @Input() public size: ComponentSizes = 'xsmall';
  @Input({ required: true }) public activeImageText!: string;
  @Input({ required: true }) public buttonImage = PcButtonIcon.WHEN_RECTANGLE;
  @Input({ required: true }) public buttonImageDesktop = PcButtonIcon.WHEN_RECTANGLE_DESK;
  @Input() public showButtonImageAirplane = true;
  @Input() public isLTR = false;
  @Input() public businessUnit = BusinessUnit.IL;

  @Output() editDates = new EventEmitter<DepartureReturnButtonState>();

  public readonly PcButtonIcon = PcButtonIcon;
  public readonly ButtonState = DepartureReturnButtonState;
  public readonly ButtonDateType = ButtonDateType;

  public buttonImageAirplaneDesktop = PcButtonIcon.AIRPLANE_RETURN_TRIP_DESK;
  public buttonImageAirplane = PcButtonIcon.AIRPLANE_RETURN_TRIP;
  public buttonImageDisabled = '';
  public isDesktopSig = signal<boolean>(false);

  private breakpointObserver = inject(BreakpointObserver);

  @HostBinding('class') get class(): string {
    return this.buttonDisplayType;
  }

  public ngOnInit(): void {
    this.initDesktopQuery();
  }

  public editSelectedDates(event: DepartureReturnButtonState): void {
    this.editDates.emit(event);
  }

  private initDesktopQuery(): void {
    this.breakpointObserver.observe([`(min-width: ${GLOBAL_BREAKPOINTS.MEDIUM}px)`]).subscribe((result) => {
      this.isDesktopSig.set(result.matches);
    });
  }
}
